module.exports = __webpack_public_path__ + "img/linkedin.48a2133d.svg";